var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlancherSurTerrePlein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.66 20.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #94704a;\n      }\n\n      .cls-2 {\n        fill: #d3d3d3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.66 0 105.21 0 80.37 20.65 90.09 20.65 110.66 3.55 110.66 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.32 0 0 13.56 0 20.65 1.19 20.65 26.03 0 16.32 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 0 3.17 3.81 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.2 0 0 4.33 0 12.4 14.92 0 5.2 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.99 0 58.15 20.65 67.87 20.65 92.71 0 82.99 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.1 0 69.26 20.65 78.98 20.65 103.82 0 94.1 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.43 0 2.59 20.65 12.31 20.65 37.15 0 27.43 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.66 20.65 110.66 13.95 102.6 20.65 110.66 20.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.65 0 24.81 20.65 34.53 20.65 59.37 0 49.65 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.88 0 47.04 20.65 56.75 20.65 81.59 0 71.88 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.66 4.71 91.49 20.65 101.2 20.65 110.66 12.79 110.66 4.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.76 0 35.93 20.65 45.64 20.65 70.48 0 60.76 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.54 0 13.7 20.65 23.42 20.65 48.26 0 38.54 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.81 0 0 3.17 0 4.33 5.2 0 3.81 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.92 0 0 12.4 0 13.56 16.32 0 14.92 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.03 0 1.19 20.65 2.59 20.65 27.43 0 26.03 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.15 0 12.31 20.65 13.7 20.65 38.54 0 37.15 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.26 0 23.42 20.65 24.81 20.65 49.65 0 48.26 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.37 0 34.53 20.65 35.93 20.65 60.76 0 59.37 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.48 0 45.64 20.65 47.04 20.65 71.88 0 70.48 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.59 0 56.75 20.65 58.15 20.65 82.99 0 81.59 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.71 0 67.87 20.65 69.26 20.65 94.1 0 92.71 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.82 0 78.98 20.65 80.37 20.65 105.21 0 103.82 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.66 3.55 90.09 20.65 91.49 20.65 110.66 4.71 110.66 3.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.66 13.95 110.66 12.79 101.2 20.65 102.6 20.65 110.66 13.95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlancherSurTerrePlein);
export default __webpack_public_path__ + "static/media/plancher-sur-terre-plein.655bb38847e29846fe341daf425bd413.svg";
export { ForwardRef as ReactComponent };